// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"0ddc061d","453":"a8f2a12d","876":"a24b6e12"}[chunkId] + ".chunk.js";
};